module.exports = __webpack_public_path__ + "img/viagem-cancun-moto.da0e4ce7.jpeg";